import React from 'react'
import Header from './Header'
import Footer from './Footer'

function Clientdetails3() {
  return (
    <div>
        <Header/>
        <Footer/>
    </div>
  )
}

export default Clientdetails3